// Pricing catalog from the client brief — Studio Cent Douze
// All prices are CAD before taxes (TPS + TVQ).

export const SECTORS = [
    "Choisir",
    "Restauration / Café",
    "Commerce de détail",
    "Services professionnels",
    "Immobilier",
    "Construction",
    "Mode / Beauté",
    "Tourisme / Hôtellerie",
    "Arts / Culture",
    "Santé / Bien-être",
    "Technologie",
    "Autre",
];

export const SITE_TYPES = [
    "Choisir",
    "Site vitrine",
    "Site e-commerce",
    "Portfolio / Studio",
    "Réservation / Booking",
    "Application web",
    "Refonte d'un site existant",
    "Création de contenu — Photo",
    "Création de contenu — Vidéo",
    "Logo & identité visuelle",
];

export const MOODS = [
    "Choisir",
    "Minimaliste & élégant",
    "Bold & expressif",
    "Chaleureux & artisanal",
    "Luxueux & premium",
    "Tech & futuriste",
    "Éditorial & magazine",
    "Naturel & organique",
];

export const TONES = [
    "Choisir",
    "Professionnel",
    "Décontracté",
    "Inspirant",
    "Humoristique",
    "Direct & efficace",
    "Poétique",
    "Familier / Tutoiement",
];

export const PRIORITIES = [
    "Choisir",
    "Standard (4-8 semaines)",
    "Accélérée (2-4 semaines)",
    "Urgente (< 2 semaines)",
];

export const COPYWRITERS = [
    "Choisir",
    "Le client rédige les textes",
    "Studio Cent Douze rédige les textes",
    "À discuter / Mixte",
];

export const PAGES = [
    { id: "accueil", label: "Accueil" },
    { id: "apropos", label: "À propos / Notre histoire" },
    { id: "services", label: "Services / Offres" },
    { id: "menu", label: "Menu / Catalogue" },
    { id: "portfolio", label: "Portfolio / Réalisations" },
    { id: "blog", label: "Blog / Nouvelles" },
    { id: "boutique", label: "Boutique en ligne" },
    { id: "reservation", label: "Réservation / Calendrier" },
    { id: "faq", label: "FAQ" },
    { id: "contact", label: "Contact" },
    { id: "carrieres", label: "Carrières" },
    { id: "galerie", label: "Galerie photos" },
];

export const ASSETS = [
    { id: "logo", label: "Logo vectoriel (.ai, .eps, .svg)" },
    { id: "photos", label: "Photos professionnelles (min. 10)" },
    { id: "textes", label: "Textes rédigés (toutes les pages)" },
    { id: "palette", label: "Palette de couleurs officielle" },
    { id: "brandguide", label: "Guide de style / brand guide" },
    { id: "videos", label: "Vidéos ou animations" },
    { id: "icones", label: "Icônes ou illustrations personnalisées" },
    { id: "temoignages", label: "Témoignages clients avec photos" },
    { id: "domaine", label: "Nom de domaine déjà acheté" },
];

export const FEATURES = [
    { id: "form", label: "Formulaire de contact" },
    { id: "stripe", label: "Paiement en ligne (Stripe)" },
    { id: "ecommerce", label: "Boutique e-commerce" },
    { id: "blog", label: "Blog / Gestion de contenu" },
    { id: "booking", label: "Réservation / Calendrier" },
    { id: "chat", label: "Chat en direct" },
    { id: "bilingue", label: "Site bilingue (FR/EN)" },
    { id: "map", label: "Carte / Localisation" },
    { id: "gallery", label: "Galerie photo interactive" },
    { id: "newsletter", label: "Infolettre / Mailchimp" },
    { id: "ga", label: "Google Analytics" },
    { id: "testimonials", label: "Section témoignages" },
    { id: "popup", label: "Popup / Bannière promo" },
    { id: "instagram", label: "Instagram feed live" },
];

// Price catalog — items selectable in the estimator
export const PRICE_GROUPS = [
    {
        id: "web_base",
        title: "Site web — base",
        items: [
            {
                id: "vitrine_1_3",
                label: "Site vitrine 1-3 pages",
                desc: "Accueil, à propos, contact",
                price: 1200,
                exclusiveGroup: "site_size",
            },
            {
                id: "vitrine_4_6",
                label: "Site vitrine 4-6 pages",
                desc: "Idéal pour PME, restaurants, studios",
                price: 2200,
                exclusiveGroup: "site_size",
            },
            {
                id: "vitrine_7_12",
                label: "Site vitrine 7-12 pages",
                desc: "Multi-services, sections riches",
                price: 3800,
                exclusiveGroup: "site_size",
            },
            {
                id: "ecommerce",
                label: "Boutique en ligne (e-commerce)",
                desc: "Jusqu'à 50 produits, intégration Stripe",
                price: 2800,
            },
            {
                id: "booking",
                label: "Système de réservation / calendrier",
                desc: "Intégration Calendly ou personnalisé",
                price: 900,
            },
            {
                id: "cms",
                label: "Blog / Gestion de contenu (CMS)",
                desc: "Le client peut publier lui-même",
                price: 600,
            },
            {
                id: "bilingue",
                label: "Version bilingue FR / EN",
                desc: "Traduction et configuration i18n",
                price: 1100,
            },
        ],
    },
    {
        id: "content",
        title: "Création de contenu",
        items: [
            {
                id: "photo",
                label: "Séance photo professionnelle",
                desc: "Demi-journée (4h) — intérieur / équipe / produits",
                price: 350,
            },
            {
                id: "video_long",
                label: "Production vidéo (court métrage)",
                desc: "Jusqu'à 90 sec — tournage et montage",
                price: 950,
            },
            {
                id: "reels",
                label: "Reels / vidéos courtes réseaux sociaux",
                desc: "15-30 sec, format vertical, sous-titres inclus",
                price: 290,
            },
            {
                id: "copy",
                label: "Rédaction de textes",
                desc: "Par page, SEO optimisé, ton adapté à la marque",
                price: 180,
            },
            {
                id: "translation",
                label: "Traduction professionnelle des textes",
                desc: "FR→EN ou EN→FR, forfait par site",
                price: 120,
            },
        ],
    },
    {
        id: "design",
        title: "Design et identité visuelle",
        items: [
            {
                id: "logo",
                label: "Conception de logo",
                desc: "3 concepts, 2 rondes de révisions, livrables vectoriels",
                price: 850,
            },
            {
                id: "brand_guide",
                label: "Guide de marque complet",
                desc: "Logo, palette, typographie, règles d'usage",
                price: 1400,
            },
            {
                id: "ui_proto",
                label: "Maquettes UI / prototype interactif",
                desc: "Figma avant le développement",
                price: 600,
            },
        ],
    },
    {
        id: "options",
        title: "Options et maintenance",
        items: [
            {
                id: "seo",
                label: "Optimisation SEO de lancement",
                desc: "Balises, vitesse, Google Search Console",
                price: 450,
            },
            {
                id: "hosting",
                label: "Configuration domaine et hébergement",
                desc: "DNS, SSL, Vercel ou Netlify — 1 an",
                price: 120,
            },
            {
                id: "maintenance",
                label: "Forfait maintenance mensuel",
                desc: "Mises à jour, sauvegardes, support / mois",
                price: 150,
                suffix: "/mois",
            },
            {
                id: "training",
                label: "Formation client (gestion autonome)",
                desc: "2h gestion du CMS, publications, mises à jour",
                price: 250,
            },
        ],
    },
];

export const PRICE_INDEX = (() => {
    const map = {};
    PRICE_GROUPS.forEach((g) =>
        g.items.forEach((it) => {
            map[it.id] = it;
        }),
    );
    return map;
})();

export function formatCAD(n) {
    return new Intl.NumberFormat("fr-CA", {
        style: "currency",
        currency: "CAD",
        maximumFractionDigits: 0,
    }).format(n);
}
